import { LicenseeModel } from 'services/EpdClient';
import themeAuOldUI from 'styles/theme/au';
import themeAuNewUI from 'styles/theme/auNew';
import themeBrOldUI from 'styles/theme/br';
import themeBrNewUI from 'styles/theme/brNew';
import themeEuOldUI from 'styles/theme/eu';
import themeEuNewUI from 'styles/theme/euNew';

export enum ProcessStatus {
  None,
  Fetching,
  Error,
  Success,
}

export enum Role {
  EPDOwner = '6462962C-5D80-E911-AD06-000D3AB8D68E',
  EPDDeveloper = '6562962c-5d80-e911-ad01-000d3ab8d68e',
  EPDVerifier = '6562962c-5d80-e911-ad03-000d3ab8d68e',
  Admin = '6262962C-5D80-E911-AD04-000D3AB8D68E',
  SysAdmin = 'E9232236-E273-4AED-953D-889AC83F11B2',
}

export enum RoleName {
  EPD_OWNER = 'EPD Owner',
  EPD_VERIFIER = 'EPD Verifier',
  LCA_PRACTITIONER = 'LCA Practitioner',
  ADMIN = 'Super Admin',
  SYSTEM_ADMIN = 'System Administrator',
  LICENSEE_ADMIN = 'Licensee Admin',
}

export enum Command {
  None,
  Inquiry,
  Connect,
}

export const CONSTRUCTION_PCR_V2_ID = '6b99d07c-4b75-4763-4485-08dd775d2e49';

export const MAX_IMG_SIZE = 1024 * 1024;
export const MAX_FILE_SIZE = 10 * 1024 * 1024;
export const MAX_COMPANY_LOGO_SIZE = 1024 * 1024;

export const MODULE_KEYS = [
  'a1',
  'a1A2A3',
  'a2',
  'a3',
  'a4',
  'a5',
  'b1',
  'b2',
  'b3',
  'b4',
  'b5',
  'b6',
  'b7',
  'c1',
  'c2',
  'c3',
  'c4',
  'd',
  'variation',
];

export const CUSTOM_RESULT_KEYS = {
  A4C4: '1',
  MODELING: '2',
  BIOGENIC: '3',
  ELECTRICITY: '4',
  BEST: '5',
  WORST: '6',
  BIOGAS: '7',
};

export const EPD_TEMPLATES_URL = 'https://environdec.com/services/epd-templates#epd-development-templates';
export const EPD_DEVELOPMENT_VERIFICATION_TEMPLATES_URL =
  'https://environdec.com/services/epd-templates#epd-verification-templates';
export const EPD_LCA_TEMPLATES_URL =
  'https://environdec.com/services/epd-templates#excel-templates-for-machine-readable-epds';
export const EPD_LCA_INDICATORS = 'https://www.environdec.com/resources/environmental-performance-indicators';
export const EPD_LCA_SELF_CHECK_GUIDE_URL =
  'https://environdec.freshdesk.com/support/solutions/articles/206000057191-troubleshooting-for-lca-data-file-errors';
export const VAT_VALIDATION_SERVICE_LINK = 'https://ec.europa.eu/taxation_customs/vies/#/vat-validation';
export const AuLicenseesCountry = ['AU', 'NZ'];
export const EUCountries = [
  'AT',
  'BE',
  'BG',
  'HR',
  'CY',
  'CZ',
  'DK',
  'EE',
  'FI',
  'FR',
  'DE',
  'GR',
  'HU',
  'IE',
  'IT',
  'LV',
  'LT',
  'LU',
  'MT',
  'NL',
  'PL',
  'PT',
  'RO',
  'SK',
  'SI',
  'ES',
  'SE',
  'XI',
];

export const REG_GUID = /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/;

export const REG_URL =
  /^((ftp|http|https):\/\/)?(www.)?(?!.*(ftp|http|https|www.))[a-zA-Z0-9_-]+(\.[a-zA-Z]+)+((\/)[\w#-]+)*(\/\w+\?[a-zA-Z0-9_]+=\w+(&[a-zA-Z0-9_]+=\w+)*)?(\/)?$/gm;

export const REG_PHONE = /^[\+]?\d{1,3}(-| )?([(]([0-9]){2,3}[)])?[-\s\.]?([0-9]{2,3}[-\s\.]?){2,}[0-9]{0,6}$/;
export const defaultThemeCode = 'GL';
export const defaultTheme = themeEuOldUI;
export const defaultLicensee: LicenseeModel = {
  id: '',
  code: defaultThemeCode,
  name: 'defaultLicensee',
  supportEmail: 'support@environdec.com',
  localHomepage: '',
};
export const themeOptions = [
  { name: 'Australasia', code: 'AU', themes: { new: themeAuNewUI, old: themeAuOldUI } },
  { name: 'Brazil', code: 'BR', themes: { new: themeBrNewUI, old: themeBrOldUI } },
  { name: 'International', code: 'GL', themes: { new: themeEuNewUI, old: themeEuOldUI } },
];

export const GLOBAL_OPTION = { value: '', label: 'Global' };

export const TOOL_TYPES = {
  LCA_TOOL: 1,
  EPD_TOOL: 2,
  INTEGRATED: 3,
};

export const NOT_ASSIGNED = 'N/A';
export const NOT_APPLICABLE = 'N/A';

export const COMMENT_MAX_LENGTH = 2000;

export enum CurrencyType {
  None = 'None',
  SEK = 'SEK',
  EUR = 'EUR',
  USD = 'USD',
}

export const MASS_FLOW_PROPERTY_DEFAULT_CONVERSION_FACTOR = 1;
export const STATUS_COMMENT_MAX_LENGTH = 60;

export const EU_COUNTRIES_NAMES = [
  'Austria',
  'Belgium',
  'Bulgaria',
  'Croatia',
  'Cyprus',
  'Czech Republic',
  'Denmark',
  'Estonia',
  'Finland',
  'France',
  'Germany',
  'Greece',
  'Hungary',
  'Ireland',
  'Italy',
  'Latvia',
  'Lithuania',
  'Luxembourg',
  'Malta',
  'The Netherlands',
  'Poland',
  'Portugal',
  'Romania',
  'Slovakia',
  'Slovenia',
  'Spain',
  'Sweden',
  'Northern Ireland',
];
